import React, { useState, useEffect } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";
import CircularProgressBar from "../../../../Common/ProgressBar/CircularProgressBar";

const MediaUploadVideo = ({ onSuccess, editData }) => {
  const [resetKey, setResetKey] = useState(Date.now());
  const [activeVideo, setActiveVideo] = useState("video1"); 
  const [videoMode, setVideoMode] = useState("file"); 
  const [video1Desktop, setVideo1Desktop] = useState(null);
  const [video1Mobile, setVideo1Mobile] = useState(null);
  const [video1DesktopLink, setVideo1DesktopLink] = useState("");
  const [video1MobileLink, setVideo1MobileLink] = useState("");
  const [video2Desktop, setVideo2Desktop] = useState(null);
  const [video2Mobile, setVideo2Mobile] = useState(null);
  const [video2DesktopLink, setVideo2DesktopLink] = useState("");
  const [video2MobileLink, setVideo2MobileLink] = useState("");
  const [bitStatus, setBitStatus] = useState("1");
  const [vchLabel, setVchLabel] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    if (editData) {
      setBitStatus(String(editData.bitStatus));
      setVchLabel(editData.vchLabel || "");

      setVideo1DesktopLink(editData.vchVideo1DesktopLink || "");
      setVideo1MobileLink(editData.vchVideo1MobileLink || "");

      setVideo2DesktopLink(editData.vchVideo2DesktopLink || "");
      setVideo2MobileLink(editData.vchVideo2MobileLink || "");

      setVideoMode(
        activeVideo === "video1"
          ? editData.vchVideo1Mode || "file"
          : editData.vchVideo2Mode || "file"
      );
    }
  }, [editData, activeVideo]);

  const resetForm = () => {
    setActiveVideo("video1");
    setVideoMode("file");

    setVideo1Desktop(null);
    setVideo1Mobile(null);
    setVideo1DesktopLink("");
    setVideo1MobileLink("");

    setVideo2Desktop(null);
    setVideo2Mobile(null);
    setVideo2DesktopLink("");
    setVideo2MobileLink("");

    setBitStatus("1");
    setVchLabel("");
    setResetKey(Date.now());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();

    if (editData?.intVideoID) {
      fd.append("intVideoID", editData.intVideoID);
    }
    fd.append("vchVideo1Mode", activeVideo === "video1" ? videoMode : editData?.vchVideo1Mode || "file");
    if (activeVideo === "video1") {
      if (videoMode === "file") {
        if (video1Desktop) fd.append("vchVideo1DesktopPath", video1Desktop);
        if (video1Mobile) fd.append("vchVideo1MobilePath", video1Mobile);
      } else {
        fd.append("vchVideo1DesktopLink", video1DesktopLink);
        fd.append("vchVideo1MobileLink", video1MobileLink);
      }
    }

    fd.append("vchVideo2Mode", activeVideo === "video2" ? videoMode : editData?.vchVideo2Mode || "file");
    if (activeVideo === "video2") {
      if (videoMode === "file") {
        if (video2Desktop) fd.append("vchVideo2DesktopPath", video2Desktop);
        if (video2Mobile) fd.append("vchVideo2MobilePath", video2Mobile);
      } else {
        fd.append("vchVideo2DesktopLink", video2DesktopLink);
        fd.append("vchVideo2MobileLink", video2MobileLink);
      }
    }

    fd.append("bitStatus", bitStatus);
    fd.append("vchLabel", vchLabel);

    setIsUploading(true);
    setUploadProgress(0);

    try {
      const res = await axios.post(
        `${REACT_APP_API_URL}api/dashboard/admin/video-upload`,
        fd,
        {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (e) =>
            setUploadProgress(Math.round((e.loaded * 100) / e.total)),
        }
      );

      alert(res.data.message);
      onSuccess?.();
      resetForm();
    } catch (err) {
      alert("Upload failed");
    } finally {
      setIsUploading(false);
    }
  };
  return (
    <div className="p-3">
      <div className="card shadow">
        <div className="card-header text-white fw-bold" style={{ background: "#0066FF" }}>
          Upload Video
        </div>

        <div className="card-body">
          <form onSubmit={handleSubmit} key={resetKey}>
            <label className="fw-bold">Select Video Slot</label>
            <select
              className="form-select mb-3"
              value={activeVideo}
              onChange={(e) => setActiveVideo(e.target.value)}
            >
              <option value="video1">Video 1</option>
              <option value="video2">Video 2</option>
            </select>
            <label className="fw-bold">Video Type</label>
            <select
              className="form-select mb-3"
              value={videoMode}
              onChange={(e) => setVideoMode(e.target.value)}
            >
              <option value="file">Upload File</option>
              <option value="link">Video Link</option>
            </select>
            {videoMode === "file" && (
              <>
                <input
                  type="file"
                  className="form-control mb-2"
                  accept="video/*"
                  onChange={(e) =>
                    activeVideo === "video1"
                      ? setVideo1Desktop(e.target.files[0])
                      : setVideo2Desktop(e.target.files[0])
                  }
                />

                <input
                  type="file"
                  className="form-control mb-3"
                  accept="video/*"
                  onChange={(e) =>
                    activeVideo === "video1"
                      ? setVideo1Mobile(e.target.files[0])
                      : setVideo2Mobile(e.target.files[0])
                  }
                />
              </>
            )}
            {videoMode === "link" && (
              <>
                <input
                  className="form-control mb-2"
                  placeholder="Desktop Video Link"
                  value={activeVideo === "video1" ? video1DesktopLink : video2DesktopLink}
                  onChange={(e) =>
                    activeVideo === "video1"
                      ? setVideo1DesktopLink(e.target.value)
                      : setVideo2DesktopLink(e.target.value)
                  }
                />
                <input
                  className="form-control mb-3"
                  placeholder="Mobile Video Link"
                  value={activeVideo === "video1" ? video1MobileLink : video2MobileLink}
                  onChange={(e) =>
                    activeVideo === "video1"
                      ? setVideo1MobileLink(e.target.value)
                      : setVideo2MobileLink(e.target.value)
                  }
                />
              </>
            )}
            <label className="fw-bold">Where to show</label>
            <select
              className="form-select mb-3"
              value={bitStatus}
              onChange={(e) => setBitStatus(e.target.value)}
            >
              <option value="1">Homepage</option>
              <option value="0">Gallery</option>
            </select>

            <label className="fw-bold">Label</label>
            <input
              className="form-control mb-3"
              value={vchLabel}
              onChange={(e) => setVchLabel(e.target.value)}
            />

            <button className="btn btn-success" disabled={isUploading}>
              {isUploading ? "Uploading..." : "Submit"}
            </button>
          </form>

          {isUploading && <CircularProgressBar progress={uploadProgress} />}
        </div>
      </div>
    </div>
  );
};

export default MediaUploadVideo;
